/**
 * Renders an achievements panel for a player
 * Grabs player ID from URL and fetches achievements data from the API
 */
import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import AchievementContainer from "./AchievementContainer";

const processAchievementsData = (jsonData) => {
  return jsonData;
};

const AchievementsPanel = () => {
  // Get player ID from URL
  const { playerId } = useParams();
  const [data, setData] = useState(undefined);

  useEffect(() => {
    setData(undefined);
    // Fetch achievements data from API
    fetch(
      `${process.env.REACT_APP_BUIHA_API_URL}/player/${playerId}/achievements/`
    )
      .then((response) => response.json())
      .then((json) => {
        let data = processAchievementsData(json);

        setData(data);
      })
      .catch((error) => console.error(error));
  }, [playerId]);

  return data && data.achievements.length > 0 ? (
    <>
      <h2 className="text-left text-xl font-bold mt-4 mb-1">
        Achievements ({data.total} Points)
      </h2>

      <div className="flex flex-row justify-center items-start flex-wrap mb-2">
        {/* For each achievement */}
        {data.achievements.map((achievement) => (
          <AchievementContainer
            achievement={achievement}
          ></AchievementContainer>
        ))}
      </div>
    </>
  ) : (
    // Loading state or no achievements
    <>
      <div className="flex flex-col justify-start items-centre my-2">
      <h2 className="text-left text-xl font-bold mt-4 mb-2">
        Achievements (0 Points)
      </h2>
        <h2 className="text-left">No Achievements Found</h2>
      </div>
    </>
  );
};

export default AchievementsPanel;
